import * as d3 from "d3"
import React, {useState, useEffect} from "react"
import legendCoverup from "./res/img/Legend Coverup.png"

const MapLegend = ({hexes, color, property, format, opacity}) => {
  let features = hexes.features
  let nstops = 5
  let extent = d3.extent(color.domain())

  let scale = d3
    .scaleLinear()
    .domain([0, 1])
    .range(extent)
  let width = 217, height = 37
  let fontSize = 13
  let observedVsExpected = "Observed # issues vs. average"
  const legendLabels = {
    "hex_population": "Population per hexagon",
    "sidewalk_score": "Sidewalk score",
    "walkability_score": "Walkability score",
    "social_need_score": "Social need score",
    "tradeoff_score": "Your combined score",
    "issues_normalized_by_population": "Number of issues per 100 people",
    "total_population": "Total population",
    "category_ratio_LIVING CONDITIONS": observedVsExpected,
    "category_ratio_PARKING": observedVsExpected,
    "category_ratio_TRASH, RECYCLING, AND WASTE": observedVsExpected,
    "category_ratio_STREETS, SIDEWALKS, AND PARKS": observedVsExpected,
    "category_ratio_BUILDING AND CONSTRUCTION": observedVsExpected,
    "category_ratio_SNOW": observedVsExpected,
    "category_ratio_ANIMALS": observedVsExpected,
    "category_ratio_TRANSPORTATION, VEHICLES, AND BICYCLES": observedVsExpected,
    "on_time_pc_smoothed": "% of on-time issues",
  }

  // A quick last-minute change to prototype transparent hexagons in the conclusion section
  let hideLegend = color("anything") === "transparent"

  return (hideLegend ? <div /> :
    <div className="App-map-legend">
      <div className="Legend-inner">
        <div className="Legend-label" title={property}>{legendLabels[property] || property}</div>
        <div className="Legend-coverup">
          <img src={legendCoverup}  width={width} height={height} title=""/>
          <svg width={width} height={height} style={{overflow: 'visible'}} >
          <defs>
            <linearGradient id="Legend-grad">
              {d3.range(nstops).map(d => {
                let pc = d / (nstops - 1)
                return (
                  <stop key={d} offset={Math.round(100*pc) + '%'} stopColor={color(scale(pc))} />
                )
              })}
            </linearGradient>
          </defs>
          <rect height={height-3} width={width-2} fill="url(#Legend-grad)"/>

          <text fontSize={fontSize} y={(height-2)/0.75} x={16}>{format(scale(0))}</text>
          <text fontSize={fontSize} y={(height-2)/0.75} x={width/2}>{format(scale(0.5))}</text>
          <text fontSize={fontSize} y={(height-2)/0.75} x={width-16}>{format(scale(1))}</text>

          </svg>
        </div>
      </div>
    </div>
  )
}

export default MapLegend